/* The Brilian — product quantity and campaign-package synchronisation */
(function(){
  'use strict';
  if (window.__brPanel) return;
  window.__brPanel = true;

  var ilkFiyatHTML = null;

  function formlar(){
    return document.querySelectorAll('form[action*="/cart/add"]');
  }

  function miktarAlanlari(){
    var nativeAlanlar = document.querySelectorAll('.product-form__quantity input[name="quantity"]');
    if (nativeAlanlar.length) return nativeAlanlar;

    var liste = [], f = formlar();
    for (var i = 0; i < f.length; i++){
      var alan = f[i].querySelector('input[name="quantity"]');
      if (!alan){
        alan = document.createElement('input');
        alan.type = 'hidden';
        alan.name = 'quantity';
        alan.value = '1';
        alan.setAttribute('data-br-miktar','');
        f[i].appendChild(alan);
      }
      liste.push(alan);
    }
    return liste;
  }

  function fiyatKutusu(){
    var k = document.querySelector('.product__info-container, .product__info-wrapper, product-info') || document;
    return k.querySelector('.price');
  }

  function anaFiyatiSakla(){
    var kutu = fiyatKutusu();
    if (kutu && ilkFiyatHTML === null) ilkFiyatHTML = kutu.innerHTML;
    return kutu;
  }

  function ilkFiyataDon(){
    var kutu = anaFiyatiSakla();
    if (kutu && ilkFiyatHTML !== null) kutu.innerHTML = ilkFiyatHTML;
    return kutu;
  }

  function fiyatiGuncelle(giris){
    var kutu = anaFiyatiSakla();
    if (!kutu) return;

    var adet = giris.getAttribute('data-adet') || '1';
    if (adet === '1'){
      ilkFiyataDon();
      return;
    }

    var etiket = document.querySelector('label[for="' + giris.id + '"]');
    if (!etiket) return;
    var yeni = etiket.querySelector('.br-pk-f');
    var eski = etiket.querySelector('.br-pk-eski');
    if (!yeni) return;

    kutu.innerHTML =
      '<div class="price__container"><div class="price__sale">' +
        '<span class="price-item price-item--sale price-item--last">' + yeni.textContent.trim() + '</span>' +
        (eski ? ' <s class="price-item price-item--regular">' + eski.textContent.trim() + '</s>' : '') +
      '</div></div>' +
      '<span class="br-pk-not">' + adet + ' adet için · indirim sepette otomatik uygulanır</span>';
  }

  function serbestAdetFiyati(adet){
    var kutu = ilkFiyataDon();
    if (!kutu || adet < 2) return;
    kutu.insertAdjacentHTML(
      'beforeend',
      '<span class="br-pk-not">' + adet + ' adet · %20 indirim sepette otomatik uygulanır</span>'
    );
  }

  function paketiMiktardanEsle(alan){
    var adet = Math.max(1, parseInt(alan.value, 10) || 1);
    var radyolar = document.querySelectorAll('[data-br-pk] input[type="radio"]');
    var eslesen = null;

    for (var i = 0; i < radyolar.length; i++){
      var ayni = parseInt(radyolar[i].getAttribute('data-adet'), 10) === adet;
      radyolar[i].checked = ayni;
      if (ayni) eslesen = radyolar[i];
    }

    if (eslesen) fiyatiGuncelle(eslesen);
    else serbestAdetFiyati(adet);
  }

  function uygula(giris){
    var adet = giris.getAttribute('data-adet') || '1';
    var alanlar = miktarAlanlari();

    for (var i = 0; i < alanlar.length; i++){
      alanlar[i].value = adet;
      alanlar[i].dispatchEvent(new Event('input', { bubbles:true }));
      alanlar[i].dispatchEvent(new Event('change', { bubbles:true }));
    }
    fiyatiGuncelle(giris);
  }

  function miktarKontrolleriniBagla(){
    var alanlar = document.querySelectorAll('.product-form__quantity input[name="quantity"]');
    for (var i = 0; i < alanlar.length; i++){
      (function(alan){
        if (alan.__brBagli) return;
        alan.__brBagli = true;
        alan.addEventListener('input', function(){ paketiMiktardanEsle(alan); });
        alan.addEventListener('change', function(){ paketiMiktardanEsle(alan); });
      })(alanlar[i]);
    }
  }

  function bagla(){
    anaFiyatiSakla();
    miktarKontrolleriniBagla();

    var g = document.querySelectorAll('[data-br-pk] input[type="radio"]');
    for (var i = 0; i < g.length; i++){
      (function(r){
        if (!r.__bagli){
          r.__bagli = true;
          r.addEventListener('change', function(){ if (r.checked) uygula(r); });
        }
        if (r.checked) uygula(r);
      })(g[i]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bagla);
  else bagla();

  document.addEventListener('shopify:section:load', function(){
    ilkFiyatHTML = null;
    bagla();
  });
})();